import register from '../../../../global/js/registry';
export default register('o-video', () => import(/* webpackMode: "lazy" */ './o-video.controller'));
